import { ApiService } from 'services';
import { history } from 'containers/App';
import CryptoJS from 'crypto-js';
import EnvConfig from 'env.config';
import { setStateStorageSetting } from 'common/storage';
import { getIgaSubClassificationCombos } from './getIgaSubClassifications';
import { getLobs } from './getLobs';

export const GET_ONLINE_CONFIG_REQUEST = 'GET_ONLINE_CONFIG_REQUEST';
export const GET_ONLINE_CONFIG_FAILURE = 'GET_ONLINE_CONFIG_FAILURE';
export const GET_ONLINE_CONFIG_SUCCESS = 'GET_ONLINE_CONFIG_SUCCESS';
export const CLEAR_ONLINE_CONFIG_DEFAULT_FORM = 'CLEAR_ONLINE_CONFIG_DEFAULT_FORM';
export const SESSION_TIME_OUT = 'SESSION_TIME_OUT';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const CLEAR_MODAL_UP_FRONT = 'CLEAR_MODAL_UP_FRONT';

function request() {
  return {
    type: GET_ONLINE_CONFIG_REQUEST,
  };
}

function receive(data) {
  let jsonObject = null;
  let key = null;
  let customerData = null;

  if (data) {
    key = data.secretKey;
    if (key) {
      const decryptedArray = CryptoJS.AES.decrypt(data.customerDetails, key);
      const decryptedText = decryptedArray.toString(CryptoJS.enc.Utf8);
      jsonObject = JSON.parse(decryptedText);

      if (jsonObject) {
        customerData = data.customerDetails;
      }
    }
  }

  return {
    type: GET_ONLINE_CONFIG_SUCCESS,
    onlineConfig: data,
    customerData,
    key
  };
}

function reject() {
  return {
    type: GET_ONLINE_CONFIG_FAILURE
  };
}

export function clearDefaultForm(defaultFormUrl) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ONLINE_CONFIG_DEFAULT_FORM,
      defaultFormUrl
    });
  };
}

export function clearModalUpFront() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_MODAL_UP_FRONT
    });
  };
}

export function timeOutSession() {
  return (dispatch) => {
    dispatch({ type: SESSION_TIME_OUT });
  };
}

function setAccountId(accountId) {
  return {
    type: SET_SELECTED_ACCOUNT,
    accountId
  };
}

export function setAccount(accountId) {
  return (dispatch) => {
    dispatch(setAccountId(parseInt(accountId, 10)));
  };
}

export function getOnlineConfig() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getOnlineConfig()
      .then((response) => {
        dispatch(receive(response.data.data));
        if (response?.data?.data?.customer) {
          const { accounts } = response.data.data.customer;
          if (accounts && accounts.length === 1) {
            dispatch(setAccount(accounts[0].id));
          }
          dispatch(getIgaSubClassificationCombos());
          dispatch(getLobs());
          setStateStorageSetting(EnvConfig.loginSessionCookieName, '1');
        }
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(reject());
          if (error.message === 'Network Error') {
            history.push('/no-internet');
          }

          if (error.response?.status) {
            if (error.response.status === 403) {
              history.push('/unlicensed');
            }

            if (error.response.status === 429
              || error.response.status === 502
              || error.response.status === 503) {
              history.push('/unavailable');
            }

            if (error.response.status === 500) {
              history.push('/server');
            }
          }
        }
      });
    return promise();
  };
}
